import { GlobalLoading, GlobalConnectionError } from '../../atoms';
import { Layout } from '@pella/react-layout';
import { Constants } from '../../../data/appConfig';
import { routes } from '../../../router/routes';

/**
 * The default layout structured with a top navbar, breadcrumb navigation, and page title.
 * Also includes a global loading indicator when any react-query queries are fetching
 */
export const MainLayout = () => (
  <>
    <Layout appName={Constants.AppName} routes={routes} hideBreadcrumbs />
    <GlobalLoading />
    <GlobalConnectionError />
  </>
);
